import type { SeriesMetadata } from "../../utils/dicomMetadataLoader";
import { derivePlane } from "../../utils/seriesClassification";
import type { PlaneOrientation } from "../../viewport/types";

/**
 * The plane a mounted volume should be resliced/geometried to.
 * A reslice pane forces the target plane; otherwise use the series' native
 * plane (drives anatomicSign/scroll), defaulting to Axial — matching the
 * GpuVolumeStrategy ACQUISITION default.
 */
export function resolveMountPlane(
  reslicePlane: PlaneOrientation | undefined,
  seriesMeta: SeriesMetadata | null | undefined,
): PlaneOrientation {
  if (reslicePlane) return reslicePlane;
  return (seriesMeta ? derivePlane(seriesMeta) : null) ?? "Axial";
}
